import React from "react";
import i18n from 'i18next'

class Theme extends React.Component {
  render() {
    const msg = this.props.Message;
    return (
      <section id="theme">
        <div className="container">
          <div className="title-block">
            <h2>{i18n.t(msg.title)}</h2>
            <div>
              <p>{i18n.t(msg.desc)}</p>
              <img className="image" src={msg.img} />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Theme;